export const COMPLETED = "COMPLETED";
export const PROCESSING_START = "PROCESSING_START";
export const PROCESSING_END = "PROCESSING_END";

export const SET_SERVER_ERROR = "SET_SERVER_ERROR";
export const RESET_SERVER_ERROR = "RESET_SERVER_ERROR";
export const SET_ERROR = "SET_ERROR";
export const SET_FIELD_VALIDATION_ERROR = "SET_FIELD_VALIDATION_ERROR";

export const REQUEST_INITIAL = "REQUEST_INITIAL";
export const RECEIVE_INITIAL = "RECEIVE_INITIAL";

export const REQUEST_PRICE = "REQUEST_PRICE";
export const RECEIVE_PRICE = "RECEIVE_PRICE";

export const REQUEST_QUOTE = "REQUEST_QUOTE";
export const RECEIVE_QUOTE = "RECEIVE_QUOTE";

export interface CompleteAction {
  type: typeof COMPLETED;
}

export interface ProcessingAction {
  type: typeof PROCESSING_START | typeof PROCESSING_END;
}

export interface InitialRequestAction {
  type: typeof REQUEST_INITIAL;
}

export function createCompleteAction(): CompleteAction {
  return { type: COMPLETED };
}

export function createStartProcessingAction(): ProcessingAction {
  return { type: PROCESSING_START };
}

export function createStopProcessingAction(): ProcessingAction {
  return { type: PROCESSING_END };
}

export function createInitialRequestAction(): InitialRequestAction {
  return { type: REQUEST_INITIAL };
}
